<template>
  <div class="paid">
    <img class="paid-img" :src="public_path + '/static/images/success_icon@3x.png'">
    <div class="hint">订单支付成功！</div>
    <div class="hint" style="margin-top: .18rem; color:rgba(51,51,51,0.5);font-size:.28rem;">订单编号：{{order.order_no}}</div>
    <div class="button">
      <div class="return-btn" @click="toIndex">返回首页</div>
      <div class="order-btn" @click="toOrder">查看订单</div>
    </div>
    <div class="footer">
      <div class="hint-1">
        <div style="font-size: .32rem;color: #F58423;">设备拆装费由当地服务商收取</div>
        <div style="color: #999999; font-size: .26rem; margin-top: .14rem;">发货后会及时短信通知您～</div>
      </div>
      <div class="hint-2">
        <div style="color: #02B389; font-size: .26rem;">如有疑问请联系客服热线：13127832213</div>
        <div style="font-size: .26rem;color: #999; margin-top: .16rem;">（周一～周五 9:00～18:00）</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      order: {},
      public_path: process.env.PUBLICK_PATH
    }
  },
  mounted () {
    this.order = JSON.parse(sessionStorage.pay)
  },
  methods: {
    toIndex () {
      let channel_no = localStorage.channel_no
      if (channel_no == 'agent') {
        this.$router.push({
          path: '/'
        })
      } else {
        this.$router.push({
          path: '/ecmall',
          query: {
            channel_no: localStorage.channel_no
          }
        })
      }
      
    },
    toOrder () {
      this.$router.push({
        path: '/ecmall/orders'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.paid {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  .paid-img {
    width: 2.5rem;
    margin: 1rem auto auto;
    display: block;
  }

  .hint {
    font-size: .32rem;
    color: #02B389;
    text-align: center;
    margin-top: 0;
  }
}
.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  .hint-2 {
    margin-bottom: .94rem;
    margin-top: .64rem;
  }
}

.button {
  margin-top: .6rem;
  font-size: .30rem;
  display: -webkit-flex;
  padding: .3rem;
  color: #fff;
  .return-btn {
    width: 3.3rem;
    height: .8rem;
    text-align: center;
    background: #02B389;
    border-radius: .4rem;
    line-height: .8rem;
    box-sizing: border-box;
  }
  .order-btn {
    width: 3.3rem;
    height: .8rem;
    text-align: center;
    border-radius: .4rem;
    border: 1px solid #02B389;
    color: #02B389;
    line-height: .8rem;
    margin-left: .3rem;
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/buy/paid.vue